export default __webpack_public_path__ + "static/vincent-5f57ce9812d5f6d8a121c39d534fca15.webp";